module.exports = __webpack_public_path__ + "img/contraceptive_voucher.a33bdc48.svg";